import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Form, Space, Row, Col, Button, Tooltip,Alert } from "antd";
import { InputCustom } from "../componentes/inputComponent";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FaRegEdit, FaRegTrashAlt, FaDownload } from "react-icons/fa";
import { manejarError } from "../manejo_errores";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { HeadersAuth, traerDatos } from "../funciones_utiles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { PlusOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import { ModalNotificacion } from "../componentes/modalNotificacion";
export const AltaCampeonato = ({ sesion, setAlerta }) => {
  //Estados del Componente
  const manejarAlertas = (tipo,mensaje ) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    nombre_campeonato: "",
    año: "",
    reglamento_general: null,
    nombre_archivo: null, // Aquí almacenaremos el archivo en Base64
  });
  const [fetchDatos, setFetchDatos] = useState([]); //Guarda los datos de los pilotos obtenidos del backend
  const [refresh, setRefresh] = useState(""); //Se utiliza para forzar la actualización de la lista de pilotos
  const [idUnico, setIdUnico] = useState(); //ID del piloto seleccionado para edición
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [abrirModalNotificacion, setAbrirModalNotificacion] = useState(false);
  const [eliminarId, setEliminarId] = useState(null);
  const [dataNotificacion, setDataNotificacion] = useState([]);
  const fileInputRef = useRef(null); // Referencia para el campo de archivo
  // Función para convertir un archivo a Base64 con encabezado
  const convertirABase64ConEncabezado = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result; // Incluye el encabezado automáticamente
        resolve(base64String); // Resuelve la cadena Base64 completa
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file); // Lee el archivo como Data URL
    });
  };
  // Manejo del cambio en el input de tipo archivo
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        // Verifica que el archivo sea un PDF
        if (!file.type.includes("pdf")) {
          // Muestra una alerta de error
          manejarAlertas("error", "El archivo debe ser un PDF válido.");
          
          return;
        }

        // Convierte el archivo a Base64 con encabezado
        const base64ConEncabezado = await convertirABase64ConEncabezado(file);

        // Actualiza el estado con el archivo Base64 y el nombre del archivo
        setTempDatosFormulario((prev) => ({
          ...prev,
          reglamento_general: base64ConEncabezado,
          nombre_archivo: file.name, // Guarda el nombre del archivo
        }));
      } catch (error) {
        manejarAlertas("error", "Ocurrió un error al procesar el archivo.");

        console.error("Error al convertir el archivo a Base64:", error);
        
      }
    }
  };
  // Vista previa del archivo cargado
  const renderFilePreview = () => {
    if (idUnico && tempDatosFormulario.nombre_archivo) {
      return (
        <div style={{ marginTop: "17px" }}>
          <Tooltip title="Descargar Reglamento" placement="top">
            <a
              href={
                process.env.REACT_APP_DOMINIO_ARCHIVOS +
                `/` +
                sesion.id_asociacion +
                `/PDFS/` +
                tempDatosFormulario.nombre_archivo
              }
              target="_blank"
              rel="noopener noreferrer"
              download
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // height: "2em",
                backgroundColor: "#223463",
                color: "#fff",
                padding: "7px 16px",
                borderRadius: "5px",
                textDecoration: "none",
                fontSize: "16px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
                marginTop: "0.88em",
              }}
            >
              <span style={{ backgroundColor: "#223463" }}>
                ↓
              </span>
            </a>
          </Tooltip>
        </div>
      );
    }
    return null;
  };

  const guardarCampeonato = async (e) => {
    try {
      let url = idUnico
        ? `${process.env.REACT_APP_DOMINIO}/campeonato/${idUnico}` // Para actualización
        : `${process.env.REACT_APP_DOMINIO}/campeonato`; // Para creación

      let response;

      if (idUnico) {
        response = await axios.put(url, tempDatosFormulario, HeadersAuth); // Actualización
      } else {
        response = await axios.post(url, tempDatosFormulario, HeadersAuth); // Creación
      }

      if (response.status === 200) {
          manejarAlertas("success","Guardado Exitoso")
        
          setTempDatosFormulario({
            nombre_campeonato: "",
            año: "",
            reglamento_general: "",
          });
          setMostrarFormulario(false);
          setMostrarBotonLimpiar(false); // Oculta el botón "+"
          // Reinicia el campo de archivo
          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Limpia el campo de archivo
          }
          setIdUnico();
          setRefresh(Date.now());
          // console.log("respo", response.data)
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true)
            setDataNotificacion(response.data.notificacionSistema);
          }
        
      }
    } catch (error) {
      // console.error("Error al guardar el campeonato:", error);
      // Muestra una alerta de error
      manejarAlertas("error",manejarError(error))
     
    }
  };
  //Obtiene la lista de campeonatos asociados a una asociación específica
  useEffect(() => {
    const fetchData = async () => {
      await fetchCampeonatos(sesion.id_asociacion);
    };

    fetchData();

    // if (fetchDatos.length > 0) {
    //   console.log("Datos de campeonatos:", fetchDatos);
    // } else {
    //   console.log("No se han encontrado pilotos.");
    // }
  }, [refresh]);
  const fetchCampeonatos = async (id_asociacion) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO +
          `/campeonato/asociacion/${id_asociacion}`
      );

      if (response.status === 200) {
        const campeonatos = Array.isArray(response.data)
          ? response.data
          : [response.data];
        setFetchDatos(campeonatos);
      } else {
        // console.error("");
        manejarAlertas("error","No se encontraron Campeonatos.");
      }
    } catch (error) {
      // console.error("Error al obtener Campeonatos:", error);
      manejarAlertas("error", manejarError(error))
    }
  };
  //Carga los datos de un campeonato para edición
  const handleEdit = async (id) => {
    if (!id) {
      // console.error("Error: idUnico es undefined");
      manejarAlertas("error", "Error");
      return;
    }
    try {
      const URI_CAMPEONATO =
        process.env.REACT_APP_DOMINIO + "/campeonato/" + id;
      const datosCampeonato = await traerDatosObjeto(URI_CAMPEONATO);
      setTempDatosFormulario(
        {
          nombre_campeonato: datosCampeonato.nombre_campeonato,
          año: datosCampeonato.año,
          reglamento_general: null,
          nombre_archivo: datosCampeonato.reglamento_general,
        } || {}
      );
      // Mostrar el formulario de gestión de pilotos
      setIdUnico(id);
      setMostrarFormulario(true);
    } catch (error) {
      // console.error("Error al obtener los datos del piloto:", error);
      manejarAlertas("error", manejarError(error));

    }
  };
  const traerDatosObjeto = async (url) => {
    try {
      const response = await axios.get(url, HeadersAuth);
      if (response.status === 200) {
        setMostrarBotonLimpiar(true);
        return response.data;
      } else {
        // console.error("Error al obtener datos:", response.statusText);
        manejarAlertas("error", "Error al obtener datos:");
        return null;
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
       // Usa la función genérica
    }
  };
  // Elimina un campeonato
  const handleEliminarCampeonato = (id) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_DOMINIO}/campeonato/pre-eliminar/${id}`,
            HeadersAuth
          );
          // console.log("Pre Eliminación:", response.data);

          // Si requiere notificación → abrir modal ANTES de eliminar
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true);
            setDataNotificacion(response.data.notificacionSistema); 

            // Guardamos ID para eliminar luego
            setEliminarId(id);
            return;
          }

          // Si NO requiere notificación → eliminar directamente
          await eliminarCampeonato(id);
        } catch (error) {
          manejarAlertas("error", manejarError(error));
        }
      }
    });
  };

  useEffect(() => {
    if (!abrirModalNotificacion && eliminarId) {
      eliminarCampeonato(eliminarId);
      setEliminarId(null);
    }
  }, [abrirModalNotificacion]);

  const eliminarCampeonato = async (id) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_DOMINIO}/campeonato/${id}`,
        HeadersAuth
      );

      manejarAlertas("success", "El campeonato ha sido eliminado.");
      setRefresh(Date.now());

    } catch (error) {
      console.error("Error al eliminar el campeonato:", error);
      manejarAlertas("error", manejarError(error));
    }
  };

  const limpiarCampos = () => {
    setTempDatosFormulario({
      nombre_campeonato: "",
      año: "",
      reglamento_general: "", // Almacena el archivo cargado temporalmente
    });
    setIdUnico(null); // Limpiar el ID del piloto seleccionado
    setMostrarBotonLimpiar(false); // Ocultar el botón "+"
  };
  // Función para mostrar el formulario y ocultar el botón
  const mostrarFormularioHandler = () => {
    setMostrarFormulario(true);
  };
 
  /*Configuración de la tabla */
  const elScroll = { x: 0 };
  const columns = [
    {
      title: "AÑO",
      key: "año",
      align: "right",
      sorter: (a, b) => a.año - b.año,
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>{a.año}</div>
      ),
    },
    {
      title: "NOMBRE CAMPEONATO",
      key: "nombre_campeonato",
      align: "left",
      sorter: (a, b) => a.nombre_campeonato.localeCompare(b.nombre_campeonato),
      render: (a) => (
        <div style={{ fontSize: "12px", padding: "2px 4px" }}>
          {a.nombre_campeonato}
        </div>
      ),
    },
    {
      title: "REGLAMENTO GENERAL",
      key: "reglamento_general",
      align: "left",
      render: (record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            padding: "2px 4px",
          }}
        >
          {/* Nombre del reglamento */}
          <span style={{ marginRight: "8px" }}>
            {record.reglamento_general || "No disponible"}
          </span>

          {/* Ícono de descarga */}
          {record.reglamento_general ? (
            <Tooltip title="Descargar Reglamento" placement="top">
              <a
                href={`${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${sesion.id_asociacion}/PDFS/${record.reglamento_general}`}
                target="_blank"
                rel="noopener noreferrer"
                download
                style={{
                  color: "#223463",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                <FaDownload />
              </a>
            </Tooltip>
          ) : null}
        </div>
      ),
    },
    {
      title: () => (
        <div style={{ textAlign: "center" }}>
          <span></span>
        </div>
      ),
      key: "opciones",
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <FaRegEdit
            className="iconos-tablas"
            style={{ color: "blue", cursor: "pointer", marginRight: "10px" }}
            onClick={() => handleEdit(record.id)}
          />
          <FaRegTrashAlt
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => handleEliminarCampeonato(record.id)}
          />
        </div>
      ),
    },
  ];

  const handleChange = (e) => {
    const { id, value } = e.target;
    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const esTelefono = useMediaQuery({ maxWidth: 768 });
  return (
    <>
     
      {/* Título-Pilotos*/}
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Gestión de campeonatos</h1>
      </section>

      {/* Formulario de Pilotos */}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* Contenedor principal para ambos formularios */}
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            padding: "20px",
            margin: "0 auto",
          }}
        >
          {mostrarFormulario && (
            <Form layout="vertical" onFinish={guardarCampeonato}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "1em",
                }}
              >
                {" "}
                <h1 className="titulos-secundarios">Datos del campeonato</h1>
                {mostrarBotonLimpiar && (
                  <BotonPrincipal
                    texto="Nuevo campeonato"
                    onClick={limpiarCampos}
                  />
                )}
              </div>
              <hr></hr>
              {/* Fila con todos los elementos */}
              <Row gutter={16}>
                {/* Primera columna: Input para "Nombre Campeonato" */}
                <Col xs={24} sm={6}>
                  <Form.Item
                    style={{
                      width: "100%",
                      // maxWidth: "300px"
                    }}
                  >
                    <InputCustom
                      idCampo="nombre_campeonato"
                      nombreCampo="Nombre del campeonato"
                      tipo="text"
                      elValue={tempDatosFormulario.nombre_campeonato || ""}
                      elPlaceholder="Ingrese el nombre del campeonato"
                      onChange={handleChange}
                      style={{
                        width: "100%",
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* Segunda columna: Input para "Año" */}
                <Col xs={24} sm={6}>
                  <Form.Item
                    style={{
                      width: "100%",
                      // maxWidth: "300px"
                    }}
                  >
                    <InputCustom
                      idCampo="año"
                      nombreCampo="Año"
                      tipo="text"
                      elValue={tempDatosFormulario.año || ""}
                      elPlaceholder="Ingrese el año"
                      onChange={handleChange}
                      style={{
                        width: "100%",
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* Tercera columna: Botón de subida de archivos */}
                <Col 
                  xs={24} sm={6}
                  className="colMostrarForm"
                  style={{ 
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    width: "100%",
                  }}
                >
                  <Form.Item
                    style={{
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                      }}
                    >
                      {/* Botón personalizado */}
                      <label
                        htmlFor="file-upload"
                        title={tempDatosFormulario.nombre_archivo || "Subir reglamento"}
                        style={{
                          display: "flex",
                          height: 30,
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#223463",
                          color: "#fff",
                          padding: "5px 20px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          fontSize: "16px",
                          border: "none",
                          outline: "none",
                          transition: "background-color 0.3s ease",
                          marginTop: "1.4em",
                          overflow: "hidden",
                          width: "100%",
                          }}
                      >
                        {/* Icono de flecha hacia arriba */}
                        <span style={{ marginRight: "10px" }}>↑</span>

                        {/* Línea vertical */}
                        <span
                          style={{
                            height: "30px",
                            width: "0.5px",
                            backgroundColor: "#fff",
                            margin: "0 10px",
                          }}
                        ></span>

                        {/* Texto dinámico con corte */}
                        <span
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden", 
                            textOverflow: "ellipsis", 
                            maxWidth: "70%", 
                            textAlign: "center",
                          }}
                        >
                          {tempDatosFormulario.nombre_archivo || "Subir reglamento"}
                        </span>
                      </label>
                      {/* Input de archivo oculto */}
                      <input
                        id="file-upload"
                        type="file"
                        accept=".pdf"
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        style={{ display: "none" }}
                      />
                    </div>
                    {/* {renderFilePreview()} */}
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} align="middle">
                {/* Cuarta columna: Botón de acción */}
                <Col xs={24} sm={6} className="botonesResponsive"
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}>
                  <Form.Item
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      height: "100%",
                    }}
                  >
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="boton-principal"
                      style={{
                        width: "100%", //
                      }}
                    >
                      {idUnico ? "Actualizar" : "Guardar"}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </section>
      {/* Tabla de resultados */}
      <div
        className="botonDescargar"
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "flex-end",
          padding:"0 16px"
        }}
      >
        <br></br>
        <TablaCompleta
          tituloPDF={"campeonatos"}
          mostrarBoton={false}
          elScroll={elScroll}
          columns={columns}
          fetchDatos={fetchDatos.length > 0 ? fetchDatos : []}
          rowKey={"id"}
          gestionTabla={
            <Row style={{ gap: "10px" }}>
              {!mostrarFormulario && (
                <BotonPrincipal
                     texto={esTelefono ? <PlusOutlined /> : "Agregar"}
                  onClick={mostrarFormularioHandler}
                />
              )}
            </Row>
          }
          mostrarBotonDescargar={false}
        />
      </div>
      {dataNotificacion.length > 0 && (
        <ModalNotificacion
          open={abrirModalNotificacion}
          onCancel={() => setAbrirModalNotificacion(false)}
          datos={dataNotificacion}
          id_asociacion={sesion.id_asociacion}
          HeadersAuth={HeadersAuth}
          setAlerta={setAlerta}
        />
      )}
    </>
  );
};
